(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-cards"] && !Shopify.designMode) return;
  try {
    
(function() {
  const cards = document.querySelectorAll('.fcc-card');
  const noResults = document.getElementById('fcc-no-results');

  // ===== 电脑端筛选 =====
  const sliderMin = document.getElementById('fcc-price-min');
  const sliderMax = document.getElementById('fcc-price-max');
  const inputMin = document.getElementById('fcc-input-min');
  const inputMax = document.getElementById('fcc-input-max');
  const rangeFill = document.getElementById('fcc-range-fill');
  const checkboxes = document.querySelectorAll('input[name="availability"]');

  function updateFill() {
    const min = parseFloat(sliderMin.value);
    const max = parseFloat(sliderMax.value);
    const total = parseFloat(sliderMin.max) - parseFloat(sliderMin.min);
    const leftPct = ((min - parseFloat(sliderMin.min)) / total) * 100;
    const rightPct = ((parseFloat(sliderMax.max) - max) / total) * 100;
    rangeFill.style.left = leftPct + '%';
    rangeFill.style.right = rightPct + '%';
  }

  function applyFilters() {
    const wantInStock = document.querySelector('input[name="availability"][value="instock"]').checked;
    const wantOutOfStock = document.querySelector('input[name="availability"][value="outofstock"]').checked;
    const minPrice = parseFloat(sliderMin.value);
    const maxPrice = parseFloat(sliderMax.value);
    let visibleCount = 0;

    cards.forEach(card => {
      const available = card.dataset.available === 'true';
      const price = parseFloat(card.dataset.price);
      const availabilityMatch = (available && wantInStock) || (!available && wantOutOfStock);
      const priceMatch = price >= minPrice && price <= maxPrice;
      if (availabilityMatch && priceMatch) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    noResults.style.display = visibleCount === 0 ? 'block' : 'none';
  }

  if (sliderMin) {
    sliderMin.addEventListener('input', function() {
      if (parseFloat(sliderMin.value) > parseFloat(sliderMax.value)) sliderMin.value = sliderMax.value;
      inputMin.value = parseFloat(sliderMin.value).toFixed(1);
      updateFill();
      applyFilters();
    });

    sliderMax.addEventListener('input', function() {
      if (parseFloat(sliderMax.value) < parseFloat(sliderMin.value)) sliderMax.value = sliderMin.value;
      inputMax.value = parseFloat(sliderMax.value).toFixed(1);
      updateFill();
      applyFilters();
    });

    inputMin.addEventListener('change', function() {
      let val = Math.max(parseFloat(sliderMin.min), Math.min(parseFloat(inputMin.value), parseFloat(sliderMax.value)));
      inputMin.value = val.toFixed(1);
      sliderMin.value = val;
      updateFill();
      applyFilters();
    });

    inputMax.addEventListener('change', function() {
      let val = Math.min(parseFloat(sliderMax.max), Math.max(parseFloat(inputMax.value), parseFloat(sliderMin.value)));
      inputMax.value = val.toFixed(1);
      sliderMax.value = val;
      updateFill();
      applyFilters();
    });

    checkboxes.forEach(cb => cb.addEventListener('change', applyFilters));
    updateFill();
  }

  // ===== 手机端抽屉 =====
  const toggle = document.getElementById('fcc-filter-toggle');
  const drawer = document.getElementById('fcc-mobile-drawer');
  const overlay = document.getElementById('fcc-drawer-overlay');
  const closeBtn = document.getElementById('fcc-drawer-close');
  const applyBtn = document.getElementById('fcc-drawer-apply');

  const sliderMinM = document.getElementById('fcc-price-min-m');
  const sliderMaxM = document.getElementById('fcc-price-max-m');
  const inputMinM = document.getElementById('fcc-input-min-m');
  const inputMaxM = document.getElementById('fcc-input-max-m');
  const rangeFillM = document.getElementById('fcc-range-fill-m');
  const checkboxesM = document.querySelectorAll('input[name="availability_m"]');

  function updateFillM() {
    const min = parseFloat(sliderMinM.value);
    const max = parseFloat(sliderMaxM.value);
    const total = parseFloat(sliderMinM.max) - parseFloat(sliderMinM.min);
    const leftPct = ((min - parseFloat(sliderMinM.min)) / total) * 100;
    const rightPct = ((parseFloat(sliderMaxM.max) - max) / total) * 100;
    rangeFillM.style.left = leftPct + '%';
    rangeFillM.style.right = rightPct + '%';
  }

  function applyFiltersMobile() {
    const wantInStock = document.querySelector('input[name="availability_m"][value="instock"]').checked;
    const wantOutOfStock = document.querySelector('input[name="availability_m"][value="outofstock"]').checked;
    const minPrice = parseFloat(sliderMinM.value);
    const maxPrice = parseFloat(sliderMaxM.value);
    let visibleCount = 0;

    cards.forEach(card => {
      const available = card.dataset.available === 'true';
      const price = parseFloat(card.dataset.price);
      const availabilityMatch = (available && wantInStock) || (!available && wantOutOfStock);
      const priceMatch = price >= minPrice && price <= maxPrice;
      if (availabilityMatch && priceMatch) {
        card.style.display = '';
        visibleCount++;
      } else {
        card.style.display = 'none';
      }
    });

    noResults.style.display = visibleCount === 0 ? 'block' : 'none';
  }

    if (toggle) {
    const headerGroup = document.querySelector('.shopify-section-group-header-group');

    function openDrawer() {
      if (headerGroup) headerGroup.style.zIndex = '1';
      drawer.classList.add('open');
    }

    function closeDrawer() {
      if (headerGroup) headerGroup.style.zIndex = '';
      drawer.classList.remove('open');
    }

    toggle.addEventListener('click', openDrawer);
    overlay.addEventListener('click', closeDrawer);
    closeBtn.addEventListener('click', closeDrawer);
    applyBtn.addEventListener('click', () => {
      applyFiltersMobile();
      closeDrawer();
    });


    sliderMinM.addEventListener('input', function() {
      if (parseFloat(sliderMinM.value) > parseFloat(sliderMaxM.value)) sliderMinM.value = sliderMaxM.value;
      inputMinM.value = parseFloat(sliderMinM.value).toFixed(1);
      updateFillM();
    });

    sliderMaxM.addEventListener('input', function() {
      if (parseFloat(sliderMaxM.value) < parseFloat(sliderMinM.value)) sliderMaxM.value = sliderMinM.value;
      inputMaxM.value = parseFloat(sliderMaxM.value).toFixed(1);
      updateFillM();
    });

    inputMinM.addEventListener('change', function() {
      let val = Math.max(parseFloat(sliderMinM.min), Math.min(parseFloat(inputMinM.value), parseFloat(sliderMaxM.value)));
      inputMinM.value = val.toFixed(1);
      sliderMinM.value = val;
      updateFillM();
    });

    inputMaxM.addEventListener('change', function() {
      let val = Math.min(parseFloat(sliderMaxM.max), Math.max(parseFloat(inputMaxM.value), parseFloat(sliderMinM.value)));
      inputMaxM.value = val.toFixed(1);
      sliderMaxM.value = val;
      updateFillM();
    });

    updateFillM();
  }

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-reel-carousel"] && !Shopify.designMode) return;
  try {
    
function vrcScroll(id, dir) {
  var track = document.getElementById('vrc-track-' + id);
  var itemWidth = track.querySelector('.vrc-item').offsetWidth + 12;
  track.scrollBy({ left: dir * itemWidth * 2, behavior: 'smooth' });
}

  } catch(e) { console.error(e); }
})();
})();
